export default {
    computed: {
        modalId: function() {
            return this.$options.name + this._uid;
        },
        remodal() {
            return $('[data-remodal-id="' + this.modalId + '"]').remodal();
        }
    },
};